<template>
    <el-row :gutter="20">
        <el-col :md="24" :sm="24" class="mb-3">
            <el-card class="profile" shadow="never">
                <div slot="header" class="">
                    <b style="font-size:18px;color: green;margin-top: 5px;padding-right:10px;">请点击查看</b>
                </div>

                <ol class="mt-3 manual-list">
                    <li v-for="item in manuals" :key="item.name">
                        <a :href="item.link" target="_blank"><i :class="item.icon"></i> {{item.name}} </a>
                    </li>
                </ol>
            </el-card>
        </el-col>
    </el-row>

</template>

<script>

    import {mapState} from "vuex";

    export default {
        name: "manual",
        data() {
            return {
                manuals: []
            }
        },
        computed: {
            ...mapState(['user', 'process']),
        },
        mounted() {
            this.getManuals()
        },
        methods: {
            getManuals: function () {
                /*
                this.$api('Admin.Manual.Manuals', {}, true).then(res => {
                    this.manual = [];
                    let divided = false;
                    let old = "";
                    res.data.data.forEach(item => {
                        item.extra_link = item.extra_link?item.extra_link:"";
                        divided = ( old === "" && item.extra_link !== "");
                        old = item.extra_link;
                        this.manuals.push({icon: item.extra_link?'el-icon-link':'el-icon-ice-cream-square', divided: divided, name: item.name, link: item.extra_link?item.extra_link:item.link});
                    });
                });
                */
            },
        }
    }
</script>

<style scoped lang="scss">

    .manual-list {
        li {
            line-height: 2.5em;

        }
    }


</style>
